import { SimpleConfirmPopup } from './components/SimpleConfirmPopup';
import { ConfirmedStatusChangesRequiredModal } from './components/ConfirmedStatusChangesRequiredModal';
import { useOfferValidation } from './hooks/useOfferValidation';
import { translate } from '../../../common/helpers/translate.helper';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { useProductContext } from '../../../common/hooks/useProductContext';
import { ValidationResponseCode } from '../../../../types/ValidationResponseCode';

export const ConfirmOrderPopup = ({ onConfirm, onDismiss, isOpen, isSubmitting, offer }) => {
    const context = useProductContext();
    const offerValidationQuery = useOfferValidation(offer, context.isLubes);
    const { addToast, addErrorToast } = useToasts();

    const onSubmit = async () => {
        try {
            await onConfirm();
            addToast(translate('alert.state.CONFIRMED.title'));
        } catch {
            addErrorToast(translate('global.genericToastError'));
        }
    };

    if (offerValidationQuery.isLoading) {
        return null;
    }

    if (context.isLubes && offerValidationQuery.data?.code === ValidationResponseCode.VALIDATION_FAILED) {
        return <ConfirmedStatusChangesRequiredModal isOpen={isOpen} onDismiss={onDismiss} offer={offer} />;
    }

    return (
        <SimpleConfirmPopup
            isOpen={isOpen}
            onSubmit={onSubmit}
            onDismiss={onDismiss}
            headline={translate('alert.confirmorder.title')}
            description={translate('alert.confirmorder.message')}
            buttonText={translate('alert.confirmorder.btnok')}
            isSubmitting={isSubmitting}
        />
    );
};
